import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlAccrual = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.35024 4.07427V14.5M5.35024 4.07427L12.7096 2.84771M5.35024 4.07427L3.29004 2.70079M3.29004 2.70079L10.2255 1.5L12.7096 2.84771V13.2734L5.35024 14.5L3.29004 13.1265V2.70079Z",
		stroke: "currentColor",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.48372 11.6922L6.54932 11.8583L8.64888 5.55924L9.6659 5.37844L11.7655 10.931L10.8311 11.0971L9.1816 6.5409L9.13602 6.549L7.48372 11.6922ZM7.6404 9.34378L10.6715 8.80491V9.55721L7.6404 10.0961V9.34378Z",
		fill: "currentColor"
	})]
});
export default SvgGlAccrual;
